import request from "../../request";
import {req} from "vuelidate/lib/validators/common";

export default {
    actions: {
        getDates(_,id){
          return request.get('newservices/'+id);
        },
        getNewProducts(_, parameters) {
            return request.get('newservices', {
                params: parameters
            })
        },
        deleteDate(_,id){
          return request.delete('newservicedate/'+id);
        },
        createNewService(_, payload) {
            return request.post('newservices', payload)
        },

        createNewServiceVSelect(_, payload) {
            return request.post('newservices?response=vselect', payload)
        },

        // update service
        updateNewService(_, payload) {
            return request.put('newservices/' + payload.id, payload.service)
        },

        // delete service
        deleteNewService(_, id) {
            return request.delete('newservices/' + id)
        },

        addStock(_, params) {
            return request.post('newservices/addStock/' + params.item.id, {newstock:params.newStock});
        }
    }
}